var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"displayNoneVuePagination"},[_c('v-client-table',{staticClass:"mgt-10px column is-12 is-paddingless",attrs:{"data":_vm.sortLiaisonsTarif,"columns":_vm.columns,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }